import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup ,CircleMarker} from 'react-leaflet';
import { Button,Row,Select,InputNumber,Col} from "antd";
import { scaleOrdinal } from 'd3-scale';
import {get} from "../../../api/get";
import LineGraph from "../../../components/Admin/Graphs/Line";
import {kmeans} from 'ml-kmeans';
import _ from 'lodash';
import 'leaflet/dist/leaflet.css';


export default function Kmeans() {
  const { Option } = Select;

  const eje = Array.from({ length: 7 }, (_, i) => {
    const angle = (2 * Math.PI / 7) * i;
    return {
      // "orderName": `Pedido ${i + 1}`,
      // "type": i % 2 === 0 ? "recogida" : "entrega",
      "longitude": -0.1195 + 0.03 * Math.cos(angle),
      "latitude": 51.5033 + 0.02 * Math.sin(angle),
      // "weight": 5,
      // "volume": 10
    };
  });

  const ejes = Array.from({ length: 5 }, (_, i) => {
    const angle = (2 * Math.PI / 5) * i;
    return {
      // "orderName": `Pedido ${i + 1}`,
      // "type": i % 2 === 0 ? "recogida" : "entrega",
      "longitude": -0.2095 + 0.03 * Math.cos(angle),
      "latitude": 51.6033 + 0.02 * Math.sin(angle),
      // "weight": 5,
      // "volume": 10
    };
  });

  var aux=eje.concat(ejes);
  const [orders, setOrders] = useState(aux);
  // const [datas, setdatas] = useState([]);
  // const [dataTabla, setdataTabla] = useState([]);
  const [elbowValue, setElbowValue] = useState(0);
  const [elbowValues, setElbowValues] = useState([]);
  const [botones, setbotones] = useState(false);
  const [hayData, sethayData] = useState(false);
  const [numClusters, setnumClusters] = useState(1);
  const [dataset, setdataset] = useState('');
  const [subsimulations, setsubsimulations] = useState([]);
  // const [inputValue, setinputValue] = useState(1);

  const colorScale1 = ['red', 'blue', 'green', 'purple', 'yellow', 'orange', 'cyan', 'magenta', 'lime', 'teal', 'pink', 'maroon', 'navy', 'olive', 'silver', 'aqua', 'fuchsia', 'indigo', 'crimson', 'gold'];
  // const colorScale = scaleOrdinal()
  //   .domain(_.range(numClusters))  // El dominio serán los números de los clusters
  //   .range(['red', 'blue', 'green', 'purple', 'yellow', 'orange', 'cyan']);  // Aquí puedes definir los colores que quieras usar

  useEffect(() => {
    // setnumClusters(inputValue)
    var DATA
    get('history-data','history-data','').then((response) => {
    // getHistoryData().then((response) => {
      var isTrue=false
      DATA = response.historyData;
      // console.log('Data: ',DATA);
      var aux=DATA.map(simul => <Option value={simul.name}>{simul.name}</Option>)
      // console.log(aux,dataset)
      setsubsimulations(aux)
      for (let i = 0; i < DATA.length; i++) {
        if(DATA[i].name===dataset){
          console.log('realdata: ',DATA[i].data)
          if(DATA[i].data.hasOwnProperty("order_lon1")&&DATA[i].data.hasOwnProperty("order_lat1")){
            var newData=[]
            for (var j = 0; j < DATA[i].data.order_lon1.length; j++) {
              var objeto = {
                latitude: DATA[i].data.order_lat1[j],
                longitude: DATA[i].data.order_lon1[j]
              };
              newData.push(objeto);
            }
            // console.log(orders,newData)
            setOrders((prev)=>newData)
            isTrue=true
          }
          break
        }
      }
      sethayData(isTrue)
      // setdatas(DATA)
      // setdataTabla(vector)
    })

  }, [botones, setbotones,dataset,setdataset]);

  const performKmeans = (orders, numClusters) => {
    const vectors = orders.map((order) => [order.longitude, order.latitude]);
    console.log('vectors: ',vectors)
    const kmeansResult = kmeans(vectors, numClusters);
    // console.log('kmeansResult',kmeansResult)
    return kmeansResult;
  };

  // const computeElbowIndex = (sseValues) => {
  //   let maxDiff = -Infinity;
  //   let elbowIndex = -1;

  //   for (let i = 1; i < sseValues.length - 1; i++) {
  //     const diff = sseValues[i - 1] - sseValues[i];
  //     if (diff > maxDiff) {
  //       maxDiff = diff;
  //       elbowIndex = i;
  //     }
  //   }

  //   return elbowIndex + 1;
  // };

  const computeElbowIndex = (sseValues) => {
    // console.log('valores:',sseValues)
    const numDataPoints = sseValues.length;
    const numClusters = numDataPoints - 2; // Restamos 2 para evitar el primer y último valor
    
    const curvatures = Array(numClusters).fill(0);
    
    for (let k = 1; k <= numClusters; k++) {
      const ssePrev = sseValues[k - 1];
      const sseCurrent = sseValues[k];
      const sseNext = sseValues[k + 1];
      
      const curvature = (ssePrev - 2 * sseCurrent + sseNext) / Math.pow(sseCurrent, 2);
      curvatures[k - 1] = curvature;
    }
    
    let maxCurvature = -Infinity;
    let elbowIndex = -1;
    
    // Calcula la media de las diferencias de error
    let sum = 0;
    for (let i = 1; i < sseValues.length; i++) {
      const difference = Math.abs(sseValues[i] - sseValues[i - 1]);
      sum += difference;
    }

    const mean = sum / (sseValues.length - 1);
    // console.log(mean,curvatures)
    var value =0.3
    if (curvatures.length>5)value=0.5
    for (let i = 0; i < curvatures.length; i++) {
      // Verifica si la diferencia de error es significativa en comparación con la media
      const diff = Math.abs(sseValues[i + 1] - sseValues[i]);
      // console.log(diff,diff > mean * value,mean * value)
      
      if (diff > mean * value) { // Ajusta el umbral según tus necesidades
        if (curvatures[i] > maxCurvature) {
          maxCurvature = curvatures[i];
          // console.log('uno',i)
          elbowIndex = i + 2;
        }
      }
    }
    // console.log('elbownumber: ',elbowIndex)
    
    return elbowIndex;
  };

  // const computeElbowIndex = (sseValues) => {
  //   const numDataPoints = sseValues.length;
  //   const numClusters = numDataPoints-2; // Restamos 2 para evitar el primer y último valor
  //   // const numClusters = numDataPoints - 2; // Restamos 2 para evitar el primer y último valor
    
  //   const curvatures = Array(numClusters).fill(0);
    
  //   for (let k = 1; k <= numClusters; k++) {
  //     const ssePrev = sseValues[k - 1];
  //     const sseCurrent = sseValues[k];
  //     const sseNext = sseValues[k + 1];
      
  //     const curvature = (ssePrev - 2 * sseCurrent + sseNext) / Math.pow(sseCurrent, 2);
  //     curvatures[k - 1] = curvature;
  //   }
    
  //   let maxCurvature = -Infinity;
  //   let elbowIndex = -1;
    
  //   for (let i = 0; i < curvatures.length; i++) {
  //     if (curvatures[i] > maxCurvature) {
  //       maxCurvature = curvatures[i];
  //       elbowIndex = i + 1;
  //     }
  //   }
    
  //   return elbowIndex;
  // };

  const evaluateElbow = () => {
    const sseValues = [];
    const sseValue = [];
    var maxK = Math.floor(orders.length / 2);
    if (maxK>10)maxK=10
    for (let k = 1; k <= maxK; k++) {
      const kmeans = performKmeans(orders, k);
      const centroids = kmeans.centroids;
      const sse = calculateSSE(orders, centroids);
      // console.log('kmeans: ',k,kmeans.centroids,sse)
      sseValues.push(sse);
      sseValue.push({'position':k-1 ,'weight':sse});
    }

    const elbowIndex = computeElbowIndex(sseValues);
    // console.log('que pasa:',elbowIndex,sseValue)
    setElbowValue(elbowIndex);
    setElbowValues(sseValue);
  };

  const calculateSSE = (data, centroids) => {
    let sse = 0;

    for (let i = 0; i < data.length; i++) {
      const point = data[i];
      // console.log('ques',point,centroids)
      const closestCentroid = findClosestCentroid(point, centroids);
      // console.log('que',closestCentroid)
      const distance = calculateDistance(point, closestCentroid);
      sse += distance ** 2;
    }

    return sse;
  };

  const findClosestCentroid = (point, centroids) => {
    let closestCentroid = null;
    let minDistance = Infinity;

    for (let i = 0; i < centroids.length; i++) {
      const centroid = centroids[i];
      // console.log('qu',i,centroid,centroid==null)
      const distance = calculateDistance(point, centroid);

      if (distance < minDistance) {
        minDistance = distance;
        closestCentroid = centroid;
      }
    }

    return closestCentroid;
  };

  const calculateDistance = (point1, point2) => {
    const { longitude: lon1, latitude: lat1 } = point1;
    const lon2= point2[0];
    const lat2= point2[1];
    // console.log('1: ',lon2, lon1,lat2, lat1)
    const lonDiff = lon2 - lon1;
    const latDiff = lat2 - lat1;

    return Math.sqrt(lonDiff ** 2 + latDiff ** 2);
  };

  useEffect(() => {
    (hayData)?evaluateElbow():console.log();
  }, [orders]);

  console.log('orders: ',orders,' numClusters: ', numClusters)
  const kmeansResult = performKmeans(orders, numClusters);
  console.log(kmeansResult)
  const ordersWithClusters = _.zipWith(orders, kmeansResult.clusters, (order, cluster) => {
    return { ...order, cluster };
  });

  function selectSubsim(value){
    setdataset((prev)=>value)
  }

  const clusters = _.groupBy(ordersWithClusters, 'cluster');

  return (
    <>
    <p></p>
      <Row align="middle" justify="space-between">
      <InputNumber
      addonBefore="Number of clusters"
      addonAfter="AI k-means"
        min={1}
        max={20}
        step={1}
        style={{
          margin: '0px 0px 0px 0px',
        }}
        defaultValue={numClusters}
        // defaultValue={inputValue}
        onChange={(value)=>{
          // setinputValue(value)
          setnumClusters(value)
        }}
      />
      {(hayData)?<Row >
        <p style={{fontFamily:'report'}}>Converged: {(kmeansResult.converged)?'Yes':'No'}</p>
        <p style={{fontFamily:'report'}}>&nbsp;&nbsp;|&nbsp;&nbsp;</p>
        <p style={{fontFamily:'report'}}>Iterations: {kmeansResult.iterations}</p>
        <p style={{fontFamily:'report'}}>&nbsp;&nbsp;|&nbsp;&nbsp;</p>
        <p style={{fontFamily:'report'}}>Elbow value: {elbowValue}</p>
      </Row>:<Row></Row>}
      <Select 
        onChange={value => selectSubsim(value)}
        placeholder="Choose dataset...   ">
        {subsimulations}
      </Select>
      </Row>
      <p></p>
      {(hayData)?<MapContainer center={[orders[0].latitude, orders[0].longitude]} zoom={13} style={{ height: "75vh", width: "100%" }}>
        <TileLayer
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {Object.keys(clusters).map((clusterKey) => {
          return clusters[clusterKey].map((order) => (
            
            // <Marker key={order.orderName} position={[order.latitude, order.longitude]}>
            <CircleMarker 
                // key={order.orderName} 
                center={[order.latitude, order.longitude]} 
                radius={5}
                color={colorScale1[clusterKey]}  // Asignamos el color de acuerdo al número de cluster
                // color={colorScale(clusterKey)}  // Asignamos el color de acuerdo al número de cluster
              >
              <Popup>
                <p>
                  Latitude: {order.latitude} <br/>
                  Longitude: {order.longitude} <br/>
                  {/* Weight: {order.weight} <br/> */}
                  {/* Volume: {order.volume} */}
                </p>
              </Popup>
              </CircleMarker>
          ));
        })}
         {kmeansResult.centroids.map((centroid, index) => (
          <Marker key={index} position={[centroid[1],centroid[0]]}>
            <Popup>
              <p>
                Centroid: {index} <br/>
                Coordinates: {centroid[0]}, {centroid[1]}
              </p>
            </Popup>
          </Marker>
        ))}
      </MapContainer>:<h1 style={{fontFamily:'report-bold'}}>Select a correct dataset to load the k-means map. The dataset must contain orders with longitude and latitude</h1>}
      <p></p>
      {(hayData)?<p style={{fontFamily:'report-bold', fontSize:'20px',textAlign:'center'}}>Elbow plot</p>:<p></p>}
      {(hayData)?<LineGraph
            data={elbowValues}
          />:<p></p>}
      {(hayData)?<p style={{fontFamily:'report', textAlign:'center'}}>Number of clusters -1</p>
        :<p></p>}
    </>
  );

};

// export default Kmeans;





